export const manualInvoiceModal = {
  modalTitle: {
    create: "Crea fattura manualmente",
    correcting: "Correggi i dati della fattura",
  },
  confirm: {
    title: "Rivedi prima di creare",
    subtitle:
      "Verrà creata una bozza. Puoi rivederla, aggiungere addebiti ed emetterla quando vuoi.",
    rowDocument: "Documento",
    documentValue: "Bozza · numero all'emissione",
    rowType: "Tipo",
    typeCompany: "Azienda / Persona giuridica",
    typeIndividual: "Privato",
    labelCompanyName: "Ragione sociale",
    labelName: "Nome",
    rowCountry: "Paese",
    rowEmail: "Email",
    rowAddress: "Indirizzo",
    rowPayment: "Pagamento",
    rowNotes: "Note",
  },
  info: {
    createTitle: "Verrà creata una fattura in BOZZA (nessun numero fino all'emissione).",
    correctingTitle: "Correzione dei dati fiscali",
    createBody:
      "Verrà salvata come bozza. Puoi aggiungere addebiti e, una volta pronta, emetterla — il numero progressivo viene assegnato dall'autorità fiscale al momento dell'emissione.",
    correctingBody:
      "Modifica solo i dati che devi correggere. Verrà generata una <strong>fattura rettificativa</strong> con i dati corretti.",
  },
  prefillLoading: "Caricamento dei dati fiscali dell'ospite…",
  // Facturar toda la reserva o una sola habitación (reservas de varias).
  scope: {
    lead: "Questa prenotazione ha più camere. Quale fattura vuoi creare?",
    continue: "Continua",
    label: "Come vuoi fatturare?",
    whole: "Tutta la prenotazione",
    wholeHint: "Una sola fattura con le {n} camere.",
    perRoom: "Una camera",
    perRoomHint: "Ogni camera, la sua fattura: le sue notti e i suoi addebiti.",
    pickRoom: "Scegli la camera",
    repeatHint: "Ripeti per ogni camera così ogni ospite ha la sua.",
  },

  recipientType: {
    label: "Tipo di destinatario",
    individual: "Privato",
    individualSub: "Persona fisica",
    company: "Azienda",
    companySub: "Persona giuridica",
    active: "Attivo",
  },
  // Buscador de clientes del fichero dentro del modal: evita teclear a mano
  // una empresa que ya está guardada.
  client: {
    label: "Cliente salvato",
    help: "Cerca un cliente in archivio e i suoi dati fiscali si compilano da soli. Se non c'è, scrivi i dati a mano.",
    clear: "Rimuovi",
    linkedHint: "Dati presi dalla scheda del cliente. Puoi correggere qualsiasi campo senza perdere il collegamento con il cliente.",
    noFiscalProfile: "Questo cliente non ha un profilo di fatturazione salvato: abbiamo preso nome ed email, il resto va scritto (oppure completa la sua scheda in Clienti).",
  },
  fields: {
    nameCompany: "Ragione sociale *",
    nameIndividual: "Nome completo *",
    country: "Paese",
    countryPlaceholder: "Seleziona il paese dell'ospite",
    countryHint: "Inserisci il paese fiscale dell'ospite per la fattura.",
    optional: "(opzionale)",
    emailLabel: "Email di fatturazione",
    phoneLabel: "Telefono",
    addressLabel: "Indirizzo fiscale",
    sectionInvoiceData: "Dati della fattura",
    paymentSourceLabel: "Fonte del pagamento",
    paymentHintPrefilled:
      "Contrassegnato in base ai pagamenti registrati. Modificalo se non è corretto.",
    paymentHintMulti:
      "Puoi contrassegnarne più di uno se il soggiorno è stato pagato in più modi.",
    paymentHintNone: "Se non contrassegni nulla, la fattura non indicherà come è stata pagata.",
    seriesLabel: "Serie",
    seriesHint: "Questa serie proviene dalle tue impostazioni di fatturazione.",
    notesLabel: "Dati aggiuntivi della fattura",
    notesHint:
      "Usalo per aggiungere una voce a testo libero, chiarimenti o dettagli aggiuntivi di emissione.",
  },
  preview: {
    label: "Prossimo numero progressivo",
    estHint: "a titolo di riferimento · assegnato all'emissione (lo prende il primo che emette)",
    noNumber: "Assegnato all'emissione · la bozza non ha numero",
  },
  footer: {
    cancel: "Annulla",
    create: "Crea fattura",
    editData: "Modifica dati",
    creating: "Creazione in corso...",
    createDraft: "Crea bozza",
  },
  success: {
    title: "Fattura emessa!",
    badge: "Emessa",
    pdfGenerating: "Il PDF è in fase di generazione. Potrebbe richiedere qualche secondo.",
    downloadPdf: "Scarica la fattura in PDF",
    generatingPdf: "Generazione del PDF…",
    sendWhatsapp: "Invia tramite WhatsApp",
    closeWindow: "Chiudi finestra",
  },
  paymentSource: {
    cash: "Contanti",
    card: "Carta di credito",
    transfer: "Bonifico bancario",
    otherOta: "Pagato tramite un'altra OTA",
  },
  prefill: {
    clientFile:
      "Dati presi dalla scheda del cliente. Controllali prima di creare la bozza.",
    invoiceRecipient: "Dati precaricati dall'ultima fattura dell'ospite.",
    chat: "Dati fiscali forniti dall'ospite al momento della richiesta della fattura. Verificali ed emetti.",
    checkin:
      "Abbiamo precaricato il nome e l'email dell'ospite dal suo check-in. Completa di seguito i suoi dati fiscali.",
    reservation:
      "Non erano presenti dati fiscali completi; come base vengono usati i dati di base della prenotazione.",
    existingInvoice:
      "Dati precaricati dalla fattura esistente. Modifica ciò che devi correggere.",
  },
  status: {
    sent: "Emessa",
    processing: "In elaborazione",
    pending: "In sospeso",
    error: "Errore",
  },
  toast: {
    whatsappSent: "Fattura inviata tramite WhatsApp.",
    whatsappError: "Impossibile inviare la fattura tramite WhatsApp.",
    draftCreated: "Bozza creata. Verificala ed emettila quando è pronta.",
  },
  validation: {
    nameRequired: "Il nome o la ragione sociale è obbligatorio.",
    countryInvalid: "Seleziona un paese valido.",
    emailInvalid: "Inserisci un'email valida.",
    taxIdRequired: "Questo identificativo fiscale è obbligatorio per questo tipo di destinatario.",
  },
  errors: {
    conflict: "La prenotazione ha già una fattura creata.",
    checkData: "Controlla i dati di fatturazione.",
    createFailed: "Impossibile creare la fattura.",
  },
  taxId: {
    labels: {
      esCompany: "NIF aziendale",
      brIndividual: "CPF o RG",
      defaultIndividual: "Numero di identificazione fiscale",
      defaultCompany: "Numero fiscale",
    },
    hints: {
      esIndividual: "DNI o NIE (X1234567A). Il passaporto non è un identificativo fiscale valido.",
      esCompany: "NIF/CIF aziendale.",
      ptIndividual: "9 cifre.",
      ptCompany: "9 cifre.",
      coIndividual: "6-10 cifre.",
      coCompany: "NIT con cifra di controllo.",
      mxIndividual: "RFC per persona fisica.",
      mxCompany: "RFC per persona giuridica.",
      arIndividual: "11 cifre con cifra di controllo.",
      arCompany: "11 cifre con cifra di controllo.",
      clIndividual: "Con cifra di controllo.",
      clCompany: "Con cifra di controllo.",
      peIndividual: "8 cifre.",
      peCompany: "11 cifre.",
      ecIndividual: "10 cifre.",
      ecCompany: "13 cifre.",
      brIndividual:
        "CPF valido per la fatturazione fiscale. Se inserisci un RG, verrà salvato come documento locale dell'ospite.",
      brCompany: "14 cifre.",
      defaultIndividual: "Opzionale.",
      defaultCompany: "Obbligatorio per le aziende.",
    },
  },
  address: {
    ES: { city: "Città", state: "Provincia", zip: "Codice postale" },
    PT: { city: "Città", state: "Distretto", zip: "Codice postale" },
    CO: { city: "Città", state: "Dip.", zip: "Codice postale" },
    MX: { city: "Città", state: "Stato", zip: "Codice postale" },
    AR: { city: "Città", state: "Provincia", zip: "Codice postale" },
    CL: { city: "Città", state: "Regione", zip: "Codice postale" },
    BR: { city: "Città", state: "Stato", zip: "CEP" },
    US: { city: "Città", state: "Stato", zip: "ZIP" },
    GB: { city: "Città", state: "Contea", zip: "Codice postale" },
    DEFAULT: { city: "Città", state: "Regione", zip: "Codice postale" },
  },
  taxErrors: {
    cifCompany: "NIF/CIF aziendale non valido.",
    esIndividual: "Documento non valido. Inserisci un DNI, NIE (X1234567A) o passaporto.",
    ptNif: "NIF non valido. Deve avere 9 cifre valide.",
    nit: "NIT non valido.",
    coCedula: "Cédula non valida. Tra 6 e 10 cifre.",
    rfc: "RFC non valido.",
    cuit: "CUIT non valido.",
    cuilCuit: "CUIL/CUIT non valido.",
    rut: "RUT non valido.",
    ruc: "RUC non valido.",
    peDni: "DNI non valido. Deve avere 8 cifre.",
    ecCedula: "Cédula non valida.",
    cnpj: "CNPJ non valido.",
    brIndividual: "Documento non valido. Usa un CPF valido o un RG nel formato consueto.",
  },
};
